import urlConfig from 'Url';

export const GET_CHANGE_COST = 'GET_CHANGE_COST';
export const GET_PRODUCTSHOW_LIST = 'GET_PRODUCTSHOW_LIST';
export const SAVE_RECOMMEND_AND_COST = 'SAVE_RECOMMEND_AND_COST';
export const EDIT_CABIN = 'EDIT_CABIN';
export const EDIT_CHANGEFARE = 'EDIT_CHANGEFARE';
export const INIT_FLIGHT = 'INIT_FLIGHT';

export function clearChangeFlight() {
  return { type: INIT_FLIGHT };
}

// 获取变更费用和升舱推荐
export function getChangeCost(data) {
  return {
    type: GET_CHANGE_COST,
    payload: {
      request: {
        url: urlConfig.queryChangeCost,
        method: 'post',
        data,
      },
    },
  };
}

export function getProductShopList(data) {
  return {
    type: GET_PRODUCTSHOW_LIST,
    payload: {
      request: {
        url: urlConfig.getProductShopList,
        method: 'post',
        data,
      },
    },
  };
}

// 修改变更手续费
export function editChangeFare(arr) {
  const data = [];
  if (Number(arr[0]) > 0) {
    data.push({
      psgType: 0,
      exchangeCost: arr[0],
    });
  }
  if (Number(arr[1]) > 0) {
    data.push({
      psgType: 1,
      exchangeCost: arr[1],
    });
  }
  if (Number(arr[2]) > 0) {
    data.push({
      psgType: 3,
      exchangeCost: arr[2],
    });
  }
  return { type: EDIT_CHANGEFARE, data };
}

// 选择推荐的升舱
export function selectCabin(n) {
  return { type: EDIT_CABIN, n };
}



// WEBPACK FOOTER //
// ./src/routes/routes/changeFlight/modules/actions.js